import React, { useState, useEffect } from "react";
import "./Budget.css";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, doc, query, where, getDocs, updateDoc } from "firebase/firestore";

const AccountantPending = () => {
    const navigate = useNavigate();

    useEffect(() => {
        if (sessionStorage.getItem("login") !== "true") {
            navigate("/")
        }
    }, [])
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [actionPlan, setActionPlan] = useState([]);
    const [demands, setDemands] = useState({});
    const [budgetData, setBudgetData] = useState({
        ageneral: 0, ascsp: 0, acfld: 0, anicra: 0, aother: 0,
        ugeneral: 0, uscsp: 0, ucfld: 0, unicra: 0, uother: 0,
        bgeneral: 0, bscsp: 0, bcfld: 0, bnicra: 0, bother: 0,
    });
    const name = localStorage.getItem("empname");
    const empId = localStorage.getItem("empid");

    window.emplist = []
    useEffect(() => {
        if (!month) return;
        if (empId == "37") {
            window.emplist = ["1", "2", "3", "4", "5", "6", "37", "42", "47", "52", "57", "62", "63", "72", "73", "82"]
        }
        if (empId == "38") {
            window.emplist = ["7", "8", "9", "10", "11", "12", "38", "43", "48", "53", "58", "64", "65", "74", "75", "83"]
        }
        if (empId == "39") {
            window.emplist = ["13", "14", "15", "16", "17", "18", "39", "44", "49", "54", "59", "66", "67", "76", "77", "84"]
        }
        if (empId == "40") {
            window.emplist = ["19", "20", "21", "22", "23", "24", "40", "45", "50", "55", "60", "68", "69", "78", "79", "85"]
        }
        if (empId == "41") {
            window.emplist = ["25", "26", "27", "28", "29", "30", "41", "46", "51", "56", "61", "70", "71", "80", "81", "86"]
        }
        console.log(window.emplist)
        const fetchActionPlan = async () => {
            try {
                const q = query(
                    collection(db, "actionplan"),
                    where("empid", "in", window.emplist),
                    where("month", "==", String(month + " " + year)),
                    where("notesheettype", "==", "general")
                );

                const querySnapshot = await getDocs(q);

                if (querySnapshot.empty) {
                    setActionPlan([]);
                    return;
                }

                const actions = [];
                const demandsObj = {};

                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    const id = doc.id;

                    const demandDate = data.demanddate?.toDate ? data.demanddate.toDate().toLocaleDateString('en-GB') : "N/A";
                    const accdate = data.demanddate && data.demanddate.toDate ? data.demanddate.toDate().toLocaleDateString('en-GB') : "N/A";

                    actions.push({
                        id: id,
                        supportdoc: data.supportdoc,
                        code: data.programCode || "",
                        text: data.program || "",
                        budgetApproved: data.budgetapproved || 0,
                        currentstatus: data.currentstatus || "Not Placed",
                        demanddate: demandDate,
                        td: data.td || "",
                        budgetDemand: data.budgetdemand || "",
                        budgethead: data.budgethead || "",
                        accdate: accdate,
                        totamount: data.totamount || "",
                        accremarks: data.accremarks || "",
                        empname: data.empname || "",
                        empdesig: data.empdesig || ""
                    });

                    demandsObj[id] = {
                        accremarks: data.accremarks || "",
                        totamount: data.totamount || "",
                        placed: data.currentstatus.includes("Forwarded to Accountant") == false,
                        currentstatus: data.currentstatus || "Not Placed",
                        demanddate: demandDate,
                        accdate: accdate,
                        budgethead: data.budgethead || "",
                    };
                });

                setActionPlan(actions);
                setDemands(demandsObj);
            } catch (error) {
                console.error("Error fetching action plans:", error);
            }
        };

        fetchActionPlan();
    }, [month, year]);

    const handleDemandPlace = async (id) => {
        const accRemarks = demands[id]?.accremarks.trim();
        const totAmount = parseFloat(demands[id]?.totamount);

        if (!accRemarks || isNaN(totAmount)) {
            alert("Please enter both accountant remarks and total amount before placing.");
            return;
        }

        try {
            const actionRef = doc(db, "actionplan", id);
            const newStatus = `Forwarded to DDO on ${new Date().toLocaleDateString("en-GB")}`;
            await updateDoc(actionRef, {
                accremarks: accRemarks,
                totamount: totAmount,
                currentstatus: newStatus,
                accdate: new Date(),
            });

            // Update demands state
            const updatedDemands = { ...demands };
            updatedDemands[id].placed = true;
            updatedDemands[id].currentstatus = newStatus;
            updatedDemands[id].demanddate = new Date().toLocaleDateString("en-GB");
            setDemands(updatedDemands);

            // Update actionPlan state
            const updatedActionPlan = actionPlan.map((action) =>
                action.id === id
                    ? {
                        ...action,
                        currentstatus: newStatus,
                        accremarks: accRemarks,
                        totamount: totAmount,
                        accdate: new Date().toLocaleDateString("en-GB"),
                    }
                    : action
            );
            setActionPlan(updatedActionPlan);
        } catch (error) {
            console.error("Error updating budget demand and totals:", error);
        }
    };

    const handleApproveForward = async (id) => {
        const accRemarks = demands[id]?.accremarks.trim();

        if (!accRemarks) {
            alert("Please add accountant remarks before approving and forwarding.");
            return;
        }

        try {
            const actionRef = doc(db, "actionplan", id);
            await updateDoc(actionRef, {
                accremarks: document.getElementById("myaccremarks").value,
                currentstatus: `Forwarded to DDO on ${new Date().toLocaleDateString('en-GB')}`,
                accdate: new Date(),
            });

            const updatedDemands = { ...demands };
            updatedDemands[id].currentstatus = `Forwarded to DDO on ${new Date().toLocaleDateString('en-GB')}`;
            setDemands(updatedDemands);
        } catch (error) {
            console.error("Error forwarding demand to DDO:", error);
        }
    };
    const handleBack = (e) => {
        e.preventDefault();
        navigate(-1)
    }
    return (
        <div className="container">
            <h1 className="welcome">Seeking Approval of Accountant</h1>

            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label className="label">Select Month and Year:</label>
                    <select className="dropdown" id="dd1" value={month} onChange={(e) => setMonth(e.target.value)}>
                        <option value="">Month</option>
                        {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((m) => (
                            <option key={m} value={m}>{m}</option>
                        ))}
                    </select>
                </div>
                <select className="dropdown" id="dd2" value={year} onChange={(e) => setYear(e.target.value)} style={{ width: '150px', height: '40px', marginTop: '33px' }}>
                    <option value="">Year</option>
                    {["2025", "2026", "2027", "2028"].map((m) => (
                        <option key={m} value={m}>{m}</option>
                    ))}
                </select>
            </div>

            {actionPlan.length > 0 && (
                <div className="action-section">
                    <table className="action-table">
                        <thead>
                            <tr>
                                <th>Applicant</th>
                                <th>Budget Head</th>
                                <th>Ref. No. & Notesheet Details</th>
                                <th>Remarks of Accountant</th>
                                <th>Supporting Document</th>
                                <th>Current Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {actionPlan.map((action) => (
                                <tr key={action.id}>
                                    <td>{action.empname} <br /> {action.empdesig}</td>
                                    <td>{action.budgethead}</td>
                                    <td>{action.code} <br /> {action.text} <br /><br /> {action.budgetDemand}</td>
                                    <td>
                                        <textarea
                                            rows="4"
                                            id="myaccremarks"
                                            className="textarea-box"
                                            placeholder="Enter your remarks"
                                            value={demands[action.id]?.accremarks || ""}
                                            onChange={(e) => {
                                                const updatedDemands = { ...demands };
                                                updatedDemands[action.id].accremarks = e.target.value;
                                                setDemands(updatedDemands);
                                            }}
                                            disabled={demands[action.id]?.placed}
                                        />
                                        <input
                                            type="number"
                                            placeholder="Enter Total Amount"
                                            value={demands[action.id]?.totamount || ""}
                                            onChange={(e) => {
                                                const updatedDemands = { ...demands };
                                                updatedDemands[action.id].totamount = e.target.value;
                                                setDemands(updatedDemands);
                                            }}
                                            disabled={demands[action.id]?.placed}
                                            className="textarea-box"
                                        />
                                        {!demands[action.id]?.placed && (
                                            <button className="place-btn full-width" onClick={() => handleDemandPlace(action.id)}>
                                                Approve & Forward
                                            </button>
                                        )}
                                    </td>
                                    <td>
                                        {action.supportdoc ? (
                                            <a href={action.supportdoc} target="_blank">
                                                <button>View Document</button>
                                            </a>
                                        ) : (
                                            ""
                                        )}
                                    </td>
                                    <td>
                                        <h4 style={{ color: demands[action.id]?.placed ? "green" : "black" }}>
                                            {action.currentstatus}
                                        </h4>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            <br /><br /><br />
            <img src="/assets/back.png" style={{ width: '100px' }} onClick={handleBack} alt="" />

        </div>
    );
};

export default AccountantPending;